import React from 'react';

/**
 * SkeletonTable - A reusable skeleton loading component for tables
 * 
 * @param {Array} columns - Array of column objects with the following structure:
 *   - title: Column header text (string)
 *   - width: Skeleton width in pixels (number, default: 120)
 *   - height: Skeleton height in pixels (number, default: 20)
 * 
 * @param {number} rows - Number of skeleton rows to display (default: 8)
 * @param {string} className - CSS class for the table element
 * 
 * @example
 * const columns = [
 *   { title: 'Name', width: 150 },
 *   { title: 'Email', width: 200 },
 *   { title: 'Status', width: 80 },
 *   { title: 'Action', width: 100, height: 32 }
 * ];
 * 
 * <SkeletonTable columns={columns} rows={5} />
 */
const SkeletonTable = ({ 
  columns = [],
  rows = 8,
  className = 'table display table-hover display mb-4 dataTablesCard card-table dataTable no-footer'
}) => {
  return (
    <table className={className}>
      <thead>
        <tr role='row'>
          {columns.map((column, index) => (
            <th key={index}>{column.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, rowIdx) => (
          <tr key={rowIdx}>
            {columns.map((column, colIdx) => (
              <td key={colIdx}>
                <div 
                  className="skeleton" 
                  style={{ 
                    width: column.width || 120, 
                    height: column.height || 20, 
                    borderRadius: 4, 
                    background: '#eee' 
                  }} 
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SkeletonTable;